var render = function render(){var _vm=this,_c=_vm._self._c;return (Array.isArray(_vm.value))?_c('FileFieldModal',{ref:"fileModal",attrs:{"files":Array.isArray(_vm.value) ? _vm.value : [_vm.value],"read-only":true}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }